var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconoOrdenar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.328,
    height: 18.961,
    viewBox: "0 0 23.328 18.961",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icono_ordenar",
    transform: "translate(78.691 -85.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2213",
    transform: "translate(-78.691 85.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path358",
    transform: "translate(3.341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2195",
    d: "M-71.992,87.4v16.116",
    transform: "translate(73.414 -85.975)",
    fill: "#119735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2192",
    d: "M-72.57,85.4a1.422,1.422,0,0,0-1.422,1.422v16.117a1.422,1.422,0,0,0,1.422,1.422,1.422,1.422,0,0,0,1.422-1.422V86.819A1.422,1.422,0,0,0-72.57,85.4Z",
    transform: "translate(73.992 -85.396)",
    fill: "#119735"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path2179",
    d: "M-77.269,103.35a1.422,1.422,0,0,0-1.005.416,1.422,1.422,0,0,0,0,2.011l3.351,3.351a1.422,1.422,0,0,0,2.011,0l3.332-3.332a1.422,1.422,0,0,0,0-2.011,1.422,1.422,0,0,0-2.011,0l-2.326,2.326-2.346-2.346a1.422,1.422,0,0,0-1.005-.417Z",
    transform: "translate(78.691 -90.584)",
    fill: "#119735"
  }), /*#__PURE__*/React.createElement("g", {
    id: "path1400",
    transform: "translate(11.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2150",
    d: "M-61,87.247h9.434",
    transform: "translate(62.315 -85.931)",
    fill: "#119735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2152",
    d: "M-61.534,85.4a1.315,1.315,0,0,0-1.315,1.316,1.315,1.315,0,0,0,1.315,1.315H-52.1a1.315,1.315,0,0,0,1.315-1.315A1.315,1.315,0,0,0-52.1,85.4Z",
    transform: "translate(62.85 -85.396)",
    fill: "#119735"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2132",
    transform: "translate(11.264 5.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2156",
    d: "M-61,94.9h7.419",
    transform: "translate(62.315 -93.587)",
    fill: "#119735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2158",
    d: "M-61.534,93.053a1.315,1.315,0,0,0-1.315,1.315,1.315,1.315,0,0,0,1.315,1.315h7.42A1.315,1.315,0,0,0-52.8,94.368a1.315,1.315,0,0,0-1.315-1.315Z",
    transform: "translate(62.85 -93.053)",
    fill: "#119735"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2134",
    transform: "translate(11.264 10.886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2162",
    d: "M-61,102.558h5.969",
    transform: "translate(62.315 -101.242)",
    fill: "#119735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2164",
    d: "M-61.534,100.707a1.315,1.315,0,0,0-1.315,1.316,1.315,1.315,0,0,0,1.315,1.315h5.969a1.315,1.315,0,0,0,1.315-1.315,1.315,1.315,0,0,0-1.315-1.317Z",
    transform: "translate(62.85 -100.707)",
    fill: "#119735"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2136",
    transform: "translate(11.264 16.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2168",
    d: "M-61,110.213h4.605",
    transform: "translate(62.315 -108.898)",
    fill: "#119735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2170",
    d: "M-61.534,108.363a1.315,1.315,0,0,0-1.315,1.315,1.315,1.315,0,0,0,1.315,1.316h4.605a1.315,1.315,0,0,0,1.315-1.315,1.315,1.315,0,0,0-1.315-1.315Z",
    transform: "translate(62.85 -108.363)",
    fill: "#119735"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoOrdenar);
export default __webpack_public_path__ + "static/media/icono-ordenar.d5a646404c9b59332350aea91ab56c4d.svg";
export { ForwardRef as ReactComponent };